export default __webpack_public_path__ + "img/ae568773069553b03af9f40eddd32ca1.png";